import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { BaseProps } from '../common/props';
// @ts-ignore
import { v4 as uuidv4 } from 'uuid';
import { Label } from '../label/Label';
import { Icon } from '../icon/Icon';
import { mcCheck, mcSquare } from '@mc/react-ui-icons';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

export interface ICheckBoxProps extends BaseProps {
  checked?: boolean;
  disabled?: boolean;
  onChange?: React.FormEventHandler<HTMLInputElement>;
  /*
   * Nepoužívat, použít children. Slouží jen jako properta pro formulář
   * */
  label?: React.ReactNode;
  indeterminate?: boolean;
  /**
   * Zda je ve výchozím stavu zaškrtnutý - pro uncontrolled mód.
   */
  defaultChecked?: boolean;
  /**
   * Je to nesmyslné. Nepoužívat.
   * @deprecated
   */
  onClick?: React.MouseEventHandler;
}

export type CheckboxProps = ICheckBoxProps;

export const Checkbox: React.FC<CheckboxProps> = ({
  className,
  checked,
  onChange,
  disabled,
  onClick,
  defaultChecked,
  title,
  indeterminate,
  children,
  label,
  dataTest,
  ...other
}) => {
  const firstRender = useRef<boolean>(true);
  const idRef = useRef<string | undefined>(undefined);
  if (firstRender.current) {
    idRef.current = uuidv4();
  }

  const [ch, setCh] = useState(
    checked !== undefined ? checked : defaultChecked
  );

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      setCh(checked);
    }
  }, [checked]);
  let icon: IconDefinition | undefined = undefined;
  if (ch) {
    icon = mcCheck;
  } else if (indeterminate && ch === undefined) {
    icon = mcSquare;
  }
  return (
    <div
      className={classNames(className, Classes.CHECKBOX, {
        [Classes.CHECKBOX_CHECKED]: ch,
        [Classes.CHECKBOX_UNCHECKED]: !ch,
        [Classes.CHECKBOX_INTERMEDIATE]: indeterminate && ch === undefined,
        [Classes.CHECKBOX_DISABLED]: disabled,
      })}
      {...other}
    >
      <div className={Classes.CHECKBOX_OW}>
        <div
          className={classNames(className, Classes.CHECKBOX_IN, {
            [Classes.CHECKBOX_CHECKED]: ch,
            [Classes.CHECKBOX_UNCHECKED]: !ch,
            [Classes.CHECKBOX_DISABLED]: disabled,
            [Classes.CHECKBOX_INTERMEDIATE]: indeterminate && ch === undefined,
          })}
          title={title}
        >
          <div className={Classes.CHECKBOX_WRAPPER}>
            <input
              data-test={dataTest ? `input-${dataTest}` : undefined}
              disabled={disabled}
              id={idRef.current}
              type="checkbox"
              checked={ch}
              onClick={(e) => onClick?.(e)}
              onChange={(e) => {
                setCh(e.target.checked);
                onChange?.(e);
              }}
            />
          </div>
          <div className={Classes.CHECKBOX_BODY}>
            {icon && <Icon fixedWidth icon={icon} />}
          </div>
        </div>
      </div>
      {children && (
        <label
          className={Classes.CHECKBOX_LABEL}
          htmlFor={idRef.current}
          tabIndex={disabled ? undefined : -1}
        >
          <Label title={title}>{children}</Label>
        </label>
      )}
      {label && label}
    </div>
  );
};
